import {useContext, useRef, useState, useEffect} from "react"
import styles from "./VoiceCallPanel.module.css"
import {VoiceCallContext} from "context/VoiceCallContext"
import Draggable from "react-draggable"
import {VoiceCallStudentPanel} from "../VoiceCallStudentPanel"
import {Settings} from "types/settings"
import {useModel} from "hooks"

export function VoiceCallPanel() {
    const {calling, activeStudent, queuedStudents, voiceProvider} = useContext(VoiceCallContext)
    const model = useModel()
    const disabledPanel = model.slug === "nau" && voiceProvider === Settings.DialerProvider.Zoom

    const containerRef = useRef<HTMLDivElement>(null)
    if ((queuedStudents.length === 0 && !calling) || !activeStudent || disabledPanel) return null

    return (
        <Draggable bounds="parent" nodeRef={containerRef}>
            <div ref={containerRef} className={styles.containerWrap}>
                <VoiceCallStudentPanel />
            </div>
        </Draggable>
    )
}
